/**
 * Different levels of error messages that we can display.
 * These are compatible with RFC5424 log levels (and the LogSeverity list).
 */
const ErrorLevel = Object.freeze({
    ERROR: 3,
    WARNING: 4,
    INFO: 6,
});

module.exports = ErrorLevel;
